module.exports = new __parcel__URL__("eye.b787035f.svg").toString();